module.exports = __webpack_public_path__ + "img/Curso_AdvanceCommunication.35e7c27f.png";